export const x = (selector, context = document) =>
  context.querySelectorAll(selector);

export const x0 = (selector, context = document) =>
  context.querySelector(selector);

export const isTouch = (() =>
  "ontouchstart" in window ||
  navigator.MaxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0)();

export const doubleDigitIntDisplay = (count) => {
  return count < 10 ? "0" + count : count;
};

export function parseCSSText(cssText) {
  const cssTxt = cssText.replace(/\/\*(.|\s)*?\*\//g, " ").replace(/\s+/g, " ");
  const style = {};
  const rule = (cssTxt.match(/ ?(.*?) ?{([^}]*)}/) || [])[2] || cssTxt;
  const cssToJs = (s) =>
    s.replace(/\W+\w/g, (match) => match.slice(-1).toUpperCase());
  const properties = rule
    .split(";")
    .map((o) => o.split(":").map((x) => x && x.trim()));
  for (const [property, value] of properties) style[cssToJs(property)] = value;
  return style;
}

export function truncateString(str, length = 7) {
  if (!str) {
    return null;
  }

  return str.length > length ? `${str.slice(0, length)}...` : str;
}

export const callAll = (...fns) => (...args) =>
  fns.forEach((fn) => fn?.(...args));

export const mediaQueries = {
  screenSmallMin: "(min-width: 375px)",
  screenSmall: "(min-width: 375px) and (max-width: 767px)",
  screenSmallMax: "(max-width: 767px)",
  screenMediumMin: "(min-width: 768px)",
  screenMedium: "(min-width: 768px) and (max-width: 1079px)",
  screenMediumMax: "(max-width: 1079px)",
  screenMediumLargeMin: "(min-width: 1080px)",
  screenMediumLarge: "(min-width: 1080px) and (max-width: 1439px)",
  screenMediumLargeMax: "(min-width: 1439px)",
  screenLargeMin: "(min-width: 1440px)",
  screenLarge: "(min-width: 1440px) and (max-width: 1647px)",
  screenLargeMax: "(max-width: 1647px)",
  screenXLargeMin: "(min-width: 1648px)",
  screenXLarge: "(min-width: 1648px) and (max-width: 1919px)",
  screenXLargeMax: "(max-width: 1919px)",
  screenXXLargeMin: "(min-width: 1920px)",
};

export function formatMillisecondToHumanMinute(ms) {
  if (!ms || ms < 1000) {
    return null;
  }
  const date = new Date(1000 * Math.round(ms / 1000)); // round to nearest second

  if (date.getUTCHours() !== 0) {
    return (
      date.getUTCHours() +
      ":" +
      pad(date.getUTCMinutes()) +
      ":" +
      pad(date.getUTCSeconds(), true)
    );
  }

  return pad(date.getUTCMinutes()) + ":" + pad(date.getUTCSeconds(), true);
}

function pad(i, includeZeroPrefix = false) {
  return (`${includeZeroPrefix ? "0" : ""}` + i).slice(-2);
}

// export const getOffsetTop = (elem) => {
//   let offsetTop = 0;
//   do {
//     if (!isNaN(elem.offsetTop)) {
//       offsetTop += elem.offsetTop;
//     }
//   } while ((elem = elem.offsetParent));
//   return offsetTop;
// };
//
// export const getScrollTop = () => {
//   if (typeof pageYOffset != 'undefined') {
//     return pageYOffset;
//   } else {
//     let doc = document,
//       B = doc.body,
//       D = doc.documentElement;
//
//     D = D.clientHeight ? D : B;
//     return D.scrollTop;
//   }
// };

export const encodeURLComponent = (str) => {
  return encodeURIComponent(str).replace(/[!'()*]/g, escape);
};

export const getFirstCharacter = (str) => {
  if (!str) {
    return "";
  }

  return str.charAt(0);
};

export const getParametersFromURL = () => {
  const re = /(?:\?|&(?:amp;)?)([^=&#]+)(?:=?([^&#]*))/g,
    params = {},
    url = document.location.href,
    decode = (s) => decodeURIComponent(s.replace(/\+/g, " "));
  let match;

  while ((match = re.exec(url))) {
    if (!params[decode(match[1])]) {
      params[decode(match[1])] = [];
    }
    params[decode(match[1])].push(decode(match[2]));
  }

  return params;
};

// export const closest = (el, parentClass) => {
//   do {
//     if (el.classList && el.classList.contains(parentClass)) {
//       return el;
//     }
//   } while ((el = el.parentNode));
//
//   return null;
// };

export const minmax = (value, min, max) => {
  const valueInt = parseInt(value, 10);
  if (isNaN(valueInt) || valueInt < min) return min;
  else if (valueInt > max) return max;
  else return value;
};

// export const setScrollTop = (offset = 0) => {
//   document.documentElement.scrollTop = document.body.scrollTop = offset;
// };
//
// export const getSiblings = (elem) => {
//   const siblings = [];
//   let sibling = elem.parentNode.firstChild;
//   while (sibling) {
//     if (sibling.nodeType === 1) {
//       siblings.push(sibling);
//     }
//     sibling = sibling.nextSibling;
//   }
//   return siblings;
// };

export function checkIfObject(obj) {
  return obj != null && obj.constructor.name === "Object";
}

export function calculateDistanceBetweenTwoNumbers(firstValue, secondValue) {
  if (firstValue === secondValue) {
    return 50;
  }
  const sum = firstValue + secondValue;
  const percentageDifference = (firstValue * 100) / sum;

  return !percentageDifference ? 1 : percentageDifference;
}

export function calculateDistanceBetweenTwoDecimals(firstValue, secondValue) {
  if (firstValue === secondValue) {
    return 50;
  }

  const sum = Number(firstValue) + Number(secondValue);
  const percentageDifference = (Number(firstValue) * 100) / sum;

  return !percentageDifference ? 1 : percentageDifference;
}

export function percentDiff(first, second, isRounded = false) {
  if (first == null || isNaN(first) || second == null || isNaN(second)) {
    return 0;
  }

  const sum = first + second;
  const percentageDifference = (first * 100) / sum;

  let value;
  value = percentageDifference;

  return isRounded ? round(value, 1) : value;
}

export function round(number, decimalSpot = 2) {
  if (typeof number !== "number") {
    return number;
  }

  return Number(number.toFixed(decimalSpot));
}

export function decimalRound(number, decimalSpot = 2) {
  if (typeof number !== "number") {
    return number;
  }

  return eval((Math.round(number * 100) / 100).toFixed(decimalSpot));
}

export function calculatePercentage(partialValue, totalValue) {
  if (!partialValue || !totalValue) {
    return decimalRound(0, 1);
  }

  return decimalRound((100 * partialValue) / totalValue, 1);
}

export function calculateSubtractedValues(firstValue = 0, secondValue = 0) {
  if ((firstValue || firstValue === 0) && (secondValue || secondValue === 0)) {
    return firstValue - secondValue;
  }

  return 0;
}

export function calculateSum(firstValue = 0, secondValue = 0) {
  if ((firstValue || firstValue === 0) && (secondValue || secondValue === 0)) {
    return firstValue + secondValue;
  }

  return 0;
}

export function titleCase(str) {
  const splitStr = str.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  return splitStr.join(" ");
}

export function getPercentageFromDecimal(decimal) {
  return Math.round(decimal * 100);
}

export function getPercentValue(value,percent){
  if(!value || !percent){
    return 0;
  }
  return Math.round((value * percent) / 100);
}

//
// export const isDesktop = () => window.outerWidth >= 1440;
// export const isTablet = () => window.outerWidth >= 768 && window.outerWidth < 1440;
// export const isMobile = () => window.outerWidth < 768;
// export const isIOS = (() => /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream)();
// export const isIE11 = !!(
//   navigator.userAgent.match(/Trident/) && navigator.userAgent.match(/rv[ :]11/)
// );

export function replaceAmpersand(str) {
  return String(str).replace(/&amp;/g, "&");
}

export function splitAndTrimStr(str) {
  if (str == null) {
    return [];
  }

  return str.split(",").map((word) => word.trim());
}

export function IsMlsCompetition(competitionId) {
  const mlsIds =
    window.forgeVariables?.match?.competitionsWithFirstSecondAssists ?? "";

  return mlsIds.includes(competitionId)
}

export function getCompetitionsToSkip() {
  const { mlsCompetitionsToSkip } = window?.forgeVariables?.match || {};

  if (!mlsCompetitionsToSkip) {
    return [];
  }

  return mlsCompetitionsToSkip?.split(",");
}